import { __rest } from "tslib";
import * as React from "react";
function SvgStatusCircleCheckmark(_a) {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2048 2048", width: "1em", height: "1em", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M1363 851l90 90-621 621-365-365 90-90 275 275 531-531z" })));
}
export default SvgStatusCircleCheckmark;
